<script>
import appConfig from "@/app.config";

import { notificationMethods } from "@/state/helpers";

export default {
  name: "app",
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    },
  },
  data() {
    return {
      meFetched: false,
      updating: true,
    }
  },
  computed:{
    canRoute() {
      return this.meFetched;
    },
    activeLoader() {
      return this.updating;
    }
  },

  created() {
    // document.querySelector("html").setAttribute('dir', 'rtl')
    // eslint-disable-next-line no-console
    this.$store.dispatch('auth/fetchMe').then(() => {
      this.meFetched = true;
      this.updating = false;
    })

  },
  watch: {
    /**
     * Clear the alert message on route change
     */
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      // clear alert on location change
      this.clearNotification();
    },
  },
  methods: {
    clearNotification: notificationMethods.clear,
  },
};
</script>

<template>
      <div id="app" style="height: 100vh" v-if="canRoute">
          <RouterView />
      </div>
</template>
